import { type InsuranceCorporateIdentity } from "../types";

export function BKKSalzgitterLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M315.888 321.686H317.728V193.373H189.414V194.753C249.662 214.069 297.032 261.439 315.888 321.686Z"
        fill="#EB6619"
      />
      <path
        d="M120.888 256.38C120.888 181.875 181.595 121.168 256.1 121.168C283.694 121.168 309.449 129.446 331.065 143.703L373.376 101.392C340.723 77.0169 300.711 62.3 256.56 62.3C149.402 62.7599 62.48 149.222 62.48 256.38C62.48 300.071 77.1969 340.543 101.572 373.196L142.963 331.804C129.166 309.729 120.888 283.974 120.888 256.38Z"
        fill="white"
      />
      <path
        d="M410.628 139.564L368.317 181.875C382.574 203.491 390.852 228.786 390.852 256.84C390.852 331.344 330.145 392.052 255.64 392.052C228.046 392.052 202.291 383.774 180.675 369.517L139.284 410.908C171.937 435.283 211.949 450 256.1 450C362.798 450 449.72 363.538 449.72 256.38C449.72 212.229 435.003 171.757 410.628 139.564Z"
        fill="white"
      />
    </svg>
  );
}

export const BKKSalzgitter: InsuranceCorporateIdentity = {
  id: "bkk-salzgitter",
  name: "BKK Salzgitter",
  logo: BKKSalzgitterLogo,
  backgroundColor: "#B0BDC7",
  textColor: "#000000",
  wildcard: "bkk salzgitter",
  type: "statutory",
};
